<template>
  <div class="layout-content">
    <RouterView />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "App"
});
</script>

<style lang="stylus">
#app
  height: 100vh;
  ::-webkit-scrollbar {
    display: none;
  }
  .layout-content
    page-fixed()
    > div
      height: 100%;
</style>
